/*
 * Employee Dashboard
 */
import React from "react";
import { useState, useEffect, useRef } from "react";
import MetaTags from "react-meta-tags";
import { toast, ToastContainer } from "react-toastify";
import {
  Col,
  Row,
  Typography,
  Avatar,
  Button,
  Modal,
  Select,
  DatePicker,
  Input,
  Divider,
  Space,
  Dropdown,
  Menu,
} from "antd";
import "./index.css";
import {
  EditOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  UpCircleFilled,
  DownCircleFilled,
  CloudUploadOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import {
  PieChart,
  Pie,
  Cell,
} from "recharts";
import TextArea from "antd/es/input/TextArea";
import AdminDashboard from "./AdminDashboard";
import { useDispatch, useSelector } from "react-redux";
import * as action from "../../store/Dashboard/actions";
import * as employeeAction from "../../store/Employee/actions";
import { isEmpty } from "lodash";
import moment from "moment";
import * as leaveAction from "../../store/LeaveAndPermission/actions";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import SimpleReactValidator from "simple-react-validator";
import api from "../../helpers";
import dayjs from "dayjs";

const Dashboard = () => {
  const userRole = localStorage.getItem("userType");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userType, setUserType] = useState(userRole);
  const [employeeCodeList, setEmployeeCodeList] = useState("");
  const [leaveType, setLeaveType] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [employeePayloadId, setEmployeePayloadId] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const [employeeCodeClear, setEmployeeCodeClear] = useState(false);
  const [leaveDuration, setLeaveDuration] = useState([]);

  const specificDispatch = useDispatch();
  const dispatch = useDispatch();
  useEffect(() => {
    if (userType === "employee") {
      specificDispatch(leaveAction.loadLeaveDetails());
      specificDispatch(leaveAction.loadLeaveDropdown());
      specificDispatch(action.loadDashboardCheckinOut());
      specificDispatch(action.loadDashboardAttendance());
      specificDispatch(action.loadBirthdayList());
      specificDispatch(action.loadHolidayList());
      specificDispatch(action.loadYearlyLeave());
      specificDispatch(action.loadDailyPercentageList());
      specificDispatch(action.loadWeeklyPercentageList());
      specificDispatch(action.loadMonthlyPercentageList());
      specificDispatch(employeeAction.loadEmployee());
    }
  }, [specificDispatch, userType]);

  const update = useSelector((state) => state.Dashboard);
  const {
    birthday_list = [],
    holiday_list = [],
    checkinOut_list = [],
    Dashboardattendence_list = [],
    Yearlyleave_list = [],
    daily_list = [],
    weekly_list = [],
    monthly_list = [],
  } = update;

  // login response

  const notifications = localStorage.getItem("welcomeNotification");

  //Initial state
  //admin //employee
  useEffect(() => {
    setUserType(userRole);
    if (notifications === true || notifications === "true") {
      const timer = setTimeout(() => {
        toast.info(`Welcome Back ! `);
        localStorage.setItem("welcomeNotification", "");
      }, 1000);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dropdownUpdate = useSelector((specificstate) => specificstate.Employee);
  const { employee_list = {} } = dropdownUpdate;
  const employeeList = employee_list ? employee_list.data : [];

  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();

  //modal initial data
  const [leaveDetails, setLeaveDetails] = useState({
    employeeCode: "",
    fromDate: "",
    toDate: "",
    reason: "",
    leaveDays: "",
  });

  const [imagePreviews, setImagePreviews] = useState([]);
  const [department, setDepartment] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const loginUser = JSON.parse(localStorage.getItem("user"));

  const loggedInEmployeeId = loginUser.employeeId; // from login API
  const matchedEmployee = employeeList?.find(
    (emp) => emp._id === loggedInEmployeeId
  );

  //dropdown state from reducer
  const dropdownLeaveUpdate = useSelector(
    (specificstate) => specificstate.Leave
  );
  const { dropDownList = {} } = dropdownLeaveUpdate;

  const [loginTime, setLoginTime] = useState(null);
  const [logoutTime, setLogoutTime] = useState(null);
  const [totalWorked, setTotalWorked] = useState("00:00:00");
  const [breakHours, setBreakHours] = useState("0m 0s");

  //Attendance segments

  const [todayHours, setTodayHours] = useState("0.00");
  const [todayPercentage, setTodayPercentage] = useState("0");

  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const todayDaily = daily_list?.data?.find((item) => item.date === today);

    if (todayDaily) {
      const minutes = todayDaily.workMinutes || 0;
      const percent = todayDaily.percentage || 0;

      setTodayHours((minutes / 60).toFixed(2));
      setTodayPercentage(percent.toFixed(2));
    }
  }, [daily_list]);

  const [weekHours, setWeekHours] = useState("0.00");
  const [weekPercentage, setWeekPercentage] = useState("0");

  useEffect(() => {
    if (weekly_list?.currentWeek) {
      const minutes = weekly_list.currentWeek.totalMinutes || 0;
      const percent = weekly_list.weeklyPercentageComparision || 0;

      setWeekHours((minutes / 60).toFixed(2)); // Convert to hours
      setWeekPercentage(percent.toFixed(2)); // Format as 2 decimal places
    }
  }, [weekly_list]);

  const [monthHours, setMonthHours] = useState("0.00");
  const [monthPercentage, setMonthPercentage] = useState("0");

  useEffect(() => {

    if (monthly_list?.currentMonth) {
      const minutes = monthly_list.currentMonth.totalMinutes || 0;
      const percent =
        monthly_list.currentMonth.percentageComparedToPreviousMonth || 0;

      setMonthHours((minutes / 60).toFixed(2));
      setMonthPercentage(percent.toFixed(2));
    }
  }, [monthly_list]);

  useEffect(() => {
    if (!Dashboardattendence_list || Dashboardattendence_list.length === 0)
      return;

    const today = moment().format("YYYY-MM-DD");
    const todayEntry = Dashboardattendence_list.find(
      (item) => item.date === today
    );
    if (!todayEntry || !todayEntry.records) return;

    const sortedData = [...todayEntry.records].sort((a, b) =>
      moment(a.time, "hh:mm A").diff(moment(b.time, "hh:mm A"))
    );

    const startTime = moment("09:00 AM", "hh:mm A");
    const endTime = moment("10:00 PM", "hh:mm A");
    const totalDuration = moment.duration(endTime.diff(startTime)).asMinutes();

    const getColor = (action1, action2) => {
      if (
        (action1 === "Login" && action2 === "Lunch Out") ||
        (action1 === "Lunch In" && action2 === "Break Out") ||
        (action1 === "Break In" && action2 === "Logout") ||
        (action1 === "Login" && action2 === "Logout")
      ) {
        return "#52C41A"; // Green
      } else if (
        (action1 === "Lunch Out" && action2 === "Lunch In") ||
        (action1 === "Break Out" && action2 === "Break In")
      ) {
        return "#FAAD14"; // Yellow
      }
      return "#ccc";
    };

    const segmentArray = [];

    for (let i = 0; i < sortedData.length - 1; i++) {
      const current = sortedData[i];
      const next = sortedData[i + 1];

      const start = moment(current.time, "hh:mm A");
      const end = moment(next.time, "hh:mm A");

      const minutesFromStart = moment
        .duration(start.diff(startTime))
        .asMinutes();
      const duration = moment.duration(end.diff(start)).asMinutes();

      // Gap before segment
      if (
        minutesFromStart > 0 &&
        (i === 0 ||
          segmentArray[segmentArray.length - 1].end !== minutesFromStart)
      ) {
        const lastEnd =
          segmentArray.length > 0
            ? segmentArray[segmentArray.length - 1].end
            : 0;
        const gapDuration = minutesFromStart - lastEnd;
        if (gapDuration > 0) {
          segmentArray.push({
            width: (gapDuration / totalDuration) * 100,
            color: "transparent",
            end: minutesFromStart,
          });
        }
      }

      segmentArray.push({
        width: (duration / totalDuration) * 100,
        color: getColor(current.action, next.action),
        end: minutesFromStart + duration,
      });
    }

    setSegments(segmentArray);

    // Generate clock labels from 09:00 AM to 10:00 PM
    const labels = [];
    for (let i = 9; i <= 22; i++) {
      labels.push(moment({ hour: i }).format("h A"));
    }
    setClockLabels(labels);
  }, [Dashboardattendence_list]);

  //Total Hours

  useEffect(() => {
    const todayDate = moment().format("YYYY-MM-DD");

    const todayRecords =
      Dashboardattendence_list.find((item) => item.date === todayDate)
        ?.records || [];

    const attendanceData = todayRecords.flat();
    const login = attendanceData.find((entry) => entry.action === "Login");
    const logout = attendanceData.find((entry) => entry.action === "Logout");

    if (login) setLoginTime(moment(login.time, "hh:mm A"));
    if (logout) {
      setLogoutTime(moment(logout.time, "hh:mm A"));

      if (logout?.totalHours) {
        const hoursMatch = logout.totalHours.match(/(\d+)\s*hours?/i);
        const minutesMatch = logout.totalHours.match(/(\d+)\s*minutes?/i);

        const hours = String(hoursMatch ? parseInt(hoursMatch[1]) : 0).padStart(
          2,
          "0"
        );
        const minutes = String(
          minutesMatch ? parseInt(minutesMatch[1]) : 0
        ).padStart(2, "0");
        const seconds = "00";

        setTotalWorked(`${hours}:${minutes}:${seconds}`);
      }
    }

    if (login && !logout) {
      const interval = setInterval(() => {
        const now = moment();
        const duration = moment.duration(
          now.diff(moment(login.time, "hh:mm A"))
        );
        const hours = String(duration.hours()).padStart(2, "0");
        const minutes = String(duration.minutes()).padStart(2, "0");
        const seconds = String(duration.seconds()).padStart(2, "0");
        setTotalWorked(`${hours}:${minutes}:${seconds}`);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [Dashboardattendence_list]);

  useEffect(() => {
    if (loginTime && !logoutTime) {
      const interval = setInterval(() => {
        const now = moment();
        const duration = moment.duration(now.diff(loginTime));
        const hours = String(duration.hours()).padStart(2, "0");
        const minutes = String(duration.minutes()).padStart(2, "0");
        const seconds = String(duration.seconds()).padStart(2, "0");
        setTotalWorked(`${hours}:${minutes}:${seconds}`);
      }, 1000);

      return () => clearInterval(interval);
    } else if (logoutTime) {
      const todayDate = moment().format("YYYY-MM-DD");
      const todayRecords =
        Dashboardattendence_list.find((item) => item.date === todayDate)
          ?.records || [];

      if (!todayRecords.length) return;

      const attendanceData = todayRecords.flat();

      const logoutEntry = attendanceData.find(
        (entry) => entry.action === "Logout"
      );

      if (logoutEntry?.totalHours) {
        const hoursMatch = logoutEntry.totalHours.match(/(\d+)\s*hours?/i);
        const minutesMatch = logoutEntry.totalHours.match(/(\d+)\s*minutes?/i);

        const hours = String(hoursMatch ? parseInt(hoursMatch[1]) : 0).padStart(
          2,
          "0"
        );
        const minutes = String(
          minutesMatch ? parseInt(minutesMatch[1]) : 0
        ).padStart(2, "0");
        const seconds = "00";

        setTotalWorked(`${hours}:${minutes}:${seconds}`);
      }
    }
  }, [loginTime, logoutTime, Dashboardattendence_list]);

  const getPieData = (totalWorked) => {
    const [hrs, mins, secs] = totalWorked.split(":").map(Number);
    const totalMinutes = hrs * 60 + mins + secs / 60;
    const maxMinutes = 10 * 60; // 10 hours = 600 mins

    const worked = Math.min(totalMinutes, maxMinutes);
    const remaining = maxMinutes - worked;

    return [
      { name: "Worked", value: worked },
      { name: "Remaining", value: remaining },
    ];
  };

  const pieData = getPieData(totalWorked);

  //Production hrs

  const [formattedWorkedHours, setFormattedWorkedHours] =
    useState("0 hrs 0 mins");
  useEffect(() => {
    if (!Dashboardattendence_list || Dashboardattendence_list.length === 0)
      return;

    const todayDate = moment().format("YYYY-MM-DD");

    const todayRecords =
      Dashboardattendence_list.find((item) => item.date === todayDate)
        ?.records || [];

    const getWorkHours = (actionName) => {
      const record = todayRecords.find(
        (r) =>
          r.action.toLowerCase() === actionName.toLowerCase() &&
          r.workHours &&
          r.workHours !== "0"
      );
      return record?.workHours || null;
    };

    const workHoursString =
      getWorkHours("Logout") ||
      getWorkHours("Break Out") ||
      getWorkHours("Lunch Out");

    if (workHoursString) {
      const hourMatch = workHoursString.match(/(\d+)\s*hour/i);
      const minuteMatch = workHoursString.match(/(\d+)\s*minute/i);

      const hrs = hourMatch ? parseInt(hourMatch[1], 10) : 0;
      const mins = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;

      setFormattedWorkedHours(`${hrs} hrs ${mins} mins`);
    } else {
      setFormattedWorkedHours("0 hrs 0 mins");
    }
  }, [Dashboardattendence_list]);

  const [location, setLocation] = useState({ lat: null, lon: null });
  const [punchInTime, setPunchInTime] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setLocation({
          lat: position.coords.latitude,
          lon: position.coords.longitude,
        });
      });
    }
  }, []);

  //break hours
  useEffect(() => {
    if (!Dashboardattendence_list || Dashboardattendence_list.length === 0)
      return;

    const today = moment().format("YYYY-MM-DD");

    const todayEntry = Dashboardattendence_list.find(
      (item) => item.date === today
    );
    if (!todayEntry || !todayEntry.records) return;

    const records = todayEntry.records;

    const getDateTime = (action) => {
      const item = records.find((r) => r.action === action);
      return item ? `${item.date} ${item.time}` : null;
    };

    const lunchOut = getDateTime("Lunch Out");
    const lunchIn = getDateTime("Lunch In");
    const breakOut = getDateTime("Break Out");
    const breakIn = getDateTime("Break In");

    let totalDuration = moment.duration();

    if (lunchOut && lunchIn) {
      const dur = moment.duration(
        moment(lunchIn, "YYYY-MM-DD hh:mm A").diff(
          moment(lunchOut, "YYYY-MM-DD hh:mm A")
        )
      );
      totalDuration.add(dur);
    }

    if (breakOut && breakIn) {
      const dur = moment.duration(
        moment(breakIn, "YYYY-MM-DD hh:mm A").diff(
          moment(breakOut, "YYYY-MM-DD hh:mm A")
        )
      );
      totalDuration.add(dur);
    }

    const hours = totalDuration.hours();
    const minutes = totalDuration.minutes();
    const seconds = totalDuration.seconds();

    const formatted = `${hours > 0 ? `${hours}h ` : ""}${minutes}m ${seconds}s`;

    setBreakHours(formatted);
  }, [Dashboardattendence_list]);

  const [isPunchedIn, setIsPunchedIn] = useState(false);
  const [isPunchOutDone, setIsPunchOutDone] = useState(false);

  const [isConfirmVisible, setIsConfirmVisible] = useState(false);

  const loginLogoutActions = checkinOut_list.filter(
    (item) => item.actionName === "Login" || item.actionName === "Logout"
  );

  const loginAction = loginLogoutActions.find(
    (item) => item.actionName === "Login"
  );
  const logoutAction = loginLogoutActions.find(
    (item) => item.actionName === "Logout"
  );

  //Punch in and Punch outgit

  useEffect(() => {
    if (!isEmpty(Dashboardattendence_list)) {
      const today = moment().format("YYYY-MM-DD");

      const todayRecord = Dashboardattendence_list.find(
        (item) => item.date === today
      );

      const actions = todayRecord?.records || [];

      const loginLogoutTodayActions = actions.filter(
        (item) => item.action === "Login" || item.action === "Logout"
      );

      const firstLogin = loginLogoutTodayActions.find(
        (item) => item.action === "Login"
      );

      const lastLoginLogoutAction =
        loginLogoutTodayActions[loginLogoutTodayActions.length - 1];

      if (firstLogin) {
        setPunchInTime((prev) =>
          prev !== firstLogin.time ? firstLogin.time : prev
        );
      }

      const isLogin = lastLoginLogoutAction?.action === "Login";
      const isLogout = lastLoginLogoutAction?.action === "Logout";

      setIsPunchedIn((prev) => (prev !== isLogin ? isLogin : prev));
      setIsPunchOutDone((prev) => (prev !== isLogout ? isLogout : prev));
    }
  }, [Dashboardattendence_list]);

  const [loader, setLoader] = useState(false);
  // handle submit employee
  const handlePunch = (e) => {
    e.preventDefault();
    setDisabled(true);
    setLoader(true); // Disable the button
    setTimeout(() => {
      setDisabled(false);
      setLoader(false); // Re-enable after 4 seconds
    }, 4000);

    const selectedActionId = isPunchedIn ? logoutAction?._id : loginAction?._id;

    const employeePayload = {
      actionId: selectedActionId,
      latitude: location.lat,
      longitude: location.lon,
    };

    api
      .post("/auth/attendance/addattendance", employeePayload)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          dispatch(action.loadDashboardAttendance());
          toast.success(
            isPunchedIn ? "Punched out successfully" : "Punched in successfully"
          );
          setIsPunchedIn((prev) => !prev);
          if (isPunchedIn) {
            setIsPunchOutDone(true);
          }
        } else {
          toast.warning(response?.data?.msg || "");
        }
        return response.data;
      })
      .catch((err) => {
        const errorMsg =
          err?.response?.data?.message || "An error occurred while login";
        toast.error(errorMsg);
        return Promise.reject(err);
      });
  };

  // const segments = [
  //   { width: 18, color: "#52C41A" },
  //   { width: 5, color: "#FAAD14" },
  //   { width: 28, color: "#52C41A" },
  //   { width: 17, color: "#FAAD14" },
  //   { width: 22, color: "#52C41A" },
  //   { width: 9, color: "#FAAD14" },
  // ];

  const [segments, setSegments] = useState([]);
  const [clockLabels, setClockLabels] = useState([]);

  //data for pieChart leave details
  // const data = [
  //   { name: "On Time", value: 1254, color: "#000000" },
  //   { name: "Late Attendance", value: 32, color: "#32CD32" },
  //   { name: "Work From Home", value: 658, color: "#FF4500" },
  //   { name: "Absent", value: 14, color: "#FF0000" },
  //   { name: "Sick Leave", value: 68, color: "#FFD700" },
  // ];

  //data for Areachart
  // const performanceData = [
  //   { month: "Jan", performance: 40 },
  //   { month: "Feb", performance: 65 },
  //   { month: "Mar", performance: 70 },
  //   { month: "Apr", performance: 55 },
  //   { month: "May", performance: 80 },
  //   { month: "Jun", performance: 95 },
  // ];

  const leaveDurationOptions = [
    { Typography: "FullDay", value: "FullDay" },
    { Typography: "Morning Session", value: "Morning Session" },
    { Typography: "Afternoon Session", value: "Afternoon Session" },
  ];

  // delete modal
  const [wishesModelOpen, setWishesModalOpen] = useState(false);

  const handleWishesModalCancel = () => {
    setWishesModalOpen(false);
  };

  const handleHolidayModalCancel = () => {
    setShowModal(false);
  };

  //delete
  const handleDelete = () => {
    setDisabled(true);
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);
  };

  //pofile picture on change and api functionality
  const handleSinglePhoto = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);
    setFileNames(fileArray[0].name);

    // Upload
    const uploadPromises = fileArray.map((file) => {
      const formData = new FormData();
      formData.append("profilePicture", file);
      return api
        .post("/auth/employee/upload-image", formData)
        .then((res) => {
          if (res?.status === 200 && res?.data?.url) {
            toast.success("Image uploaded successfully!", {
              containerId: "toast-1",
            });
            return {
              url: res.data.url,
              name: res.data.url,
            };
          } else {
            const errorMsg = res?.data?.error?.message || "Upload failed.";
            toast.error(errorMsg, { containerId: "toast-1" });
            return null;
          }
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.error?.message || "Upload error occurred.";
          toast.error(errorMsg, { containerId: "toast-1" });
          return null;
        });
    });

    const uploadedImages = await Promise.all(uploadPromises);
    const validUploads = uploadedImages.filter(Boolean);
    setImagePreviews(validUploads);
  };

  //image preview handler
  const handleRemoveImage = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };

  // Generate an array of the last 10 years starting from 2025
  const currentYear = 2025;
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const years = Array.from({ length: 10 }, (_, index) => currentYear - index);

  const handleMenuClick = (e) => {
    const year = parseInt(e.key, 10);
    setSelectedYear(year); // update state
    dispatch(action.loadYearlyLeave({ year }));
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {years.map((year) => (
        <Menu.Item key={year}>{year}</Menu.Item>
      ))}
    </Menu>
  );

  //submit functionality

  const handleSubmit = (e) => {
    setDisabled(true); // Disable the button
    setTimeout(() => {
      setDisabled(false); // Re-enable after 4 seconds
    }, 4000);

    if (simpleValidator.current.allValid()) {
      const payload = {
        EmployeeId: employeePayloadId,
        leaveMode: leaveDuration.value,
        leaveType: leaveType.value,
        fromDate: leaveDetails.fromDate.format("YYYY-MM-DD"),
        toDate:
          leaveDuration.value === "FullDay"
            ? leaveDetails.toDate.format("YYYY-MM-DD")
            : leaveDetails.fromDate.format("YYYY-MM-DD"),
        noOfDays: leaveDetails.leaveDays,
        reason: leaveDetails.reason,
        status: 1,
        ...(!isEmpty(imagePreviews) && { attachment: imagePreviews[0].url }),
      };

      api
        .post("/auth/apply", payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(leaveAction.loadLeaveDetails());
            toast.success("Leave Details added successfully");
          } else {
            toast.warning(response?.data?.msg || "");
          }
          setIsModalVisible(false);
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
            err?.response?.data?.message ||
            "An error occurred while adding the Leave details";
          toast.error(errorMsg, { containerId: "toast-1" });
          return Promise.reject(err);
        });

      //  setIsEdit(false);
    } else {
      simpleValidator.current.showMessages(); // SHOW all error messages
      forceUpdate(1);
    }
  };

  const handleEmployeeSelect = (selectedEmployee) => {
    //   setEmployeeCodeList(selectedEmployee);

    if (selectedEmployee.departmentName) {
      setDepartment({
        label: selectedEmployee.departmentName,
        value: selectedEmployee._id,
      });
    }

    if (selectedEmployee.designationName) {
      setDesignation({
        label: selectedEmployee.designationName,
        value: selectedEmployee._id,
      });
    }
  };

  const [wish, setWish] = useState("");
  const handleWishChange = (e) => {
    const { name, value } = e.target;
    if (name === "wish") {
      setWish(value);
    }
  };

  const timeRef = useRef(new Date());
  const timeDisplayRef = useRef();

  useEffect(() => {
    const intervalId = setInterval(() => {
      timeRef.current = new Date();
      if (timeDisplayRef.current) {
        // Update DOM directly with formatted time
        timeDisplayRef.current.textContent = moment(timeRef.current).format(
          "hh:mm:ss A"
        );
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  //modal handling
  const showModalOpen = () => {
    setIsModalVisible(true);
    simpleValidator.current.hideMessages();
    simpleValidator.current.hideMessageFor("password");
    forceUpdate(3);
    clearModelData();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  //date handling
  const handleDateChange = (field, date) => {
    const updatedDetails = { ...leaveDetails, [field]: date };

    const { fromDate, toDate } = updatedDetails;

    let days = "";
    if (fromDate && !toDate) {
      days = leaveDuration?.value === "FullDay" ? 1 : 0.5;
    } else if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      const diffInTime = end.getTime() - start.getTime();
      days =
        diffInTime >= 0 ? Math.floor(diffInTime / (1000 * 3600 * 24)) + 1 : 0;
    }

    updatedDetails.leaveDays = `${days} ${days === 0.5 || days === 1 ? "day" : "days"
      }`;
    setLeaveDetails(updatedDetails);
  };

  //modal input handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeaveDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // modal clear data
  const clearModelData = () => {
    setLeaveDetails({
      employeeCode: "",
      fromDate: "",
      toDate: "",
      reason: "",
      leaveDays: "",
    });
    // setEmployeeCodeClear(true);
    setTimeout(() => {
      // setEmployeeCodeClear(false);
    }, 0);
    setEmployeeCodeList([]);
    setDepartment([]);
    setDesignation([]);
    setLeaveType([]);
    setLeaveDuration([]);
    setFileNames([]);
    setImagePreviews([]);
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    // setLoading(true);
    setTimeout(() => {
      // setLoading(false);
    }, 1500);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fuseOptions = {
    keys: ["employeeCode", "label"],
  };

  const handleEmployeeCodeClear = () => {
    setEmployeeCodeList([]);
    clearModelData();

    setEmployeeCodeClear(true);
    setTimeout(() => {
      setEmployeeCodeClear(false);
    }, 0);
  };

  //dropdown options

  // sl cl options conditions

  const matchEmployee = dropDownList?.employeeOptions?.find(
    (emp) => emp._id === loggedInEmployeeId
  );

  useEffect(() => {
    if (
      userType === "employee" &&
      dropDownList?.employeeOptions?.length > 0 &&
      loggedInEmployeeId &&
      isModalVisible
    ) {
      const matchedEmployee = dropDownList.employeeOptions.find(
        (emp) => emp._id === loggedInEmployeeId
      );

      if (matchedEmployee) {
        setEmployeeCodeList(matchedEmployee.label);
        setEmployeePayloadId(matchedEmployee._id);
        handleEmployeeSelect(matchedEmployee);
      }
    }
  }, [
    userType,
    dropDownList?.employeeOptions,
    loggedInEmployeeId,
    isModalVisible,
  ]);

  const leaveOptions = [
    {
      Typography: "CL",
      value: "CL",
      disabled: matchEmployee?.isCl === false, // disable if isCl is false
    },
    {
      Typography: "SL",
      value: "SL",
      disabled: matchEmployee?.isSl === false, // disable if isSl is false
    },
    {
      Typography: "GL",
      value: "GL",
      disabled: false, // Always enabled
    },
  ];
  const today = moment().startOf("day");
  const tomorrow = moment().add(1, "day").startOf("day");

  const labeledItems =
    !isEmpty(birthday_list) &&
    birthday_list
      .map((item) => {
        const dob = moment(item.DOB, "YYYY-MM-DD").year(today.year());

        if (dob.isSame(today, "day")) {
          return { ...item, group: "Today", sortOrder: 0 };
        } else if (dob.isAfter(today, "day")) {
          return {
            ...item,
            group: dob.format("DD MMM YYYY"),
            sortOrder: 2,
            groupDate: dob.toDate(),
          };
        }

        return null;
      })
      .filter(Boolean);

  // Ensure labeledItems is an array
  const safeLabeledItems = Array.isArray(labeledItems) ? labeledItems : [];

  // Group by label
  const grouped = safeLabeledItems.reduce((acc, item) => {
    const groupKey = item.group || "Ungrouped";
    acc[groupKey] = acc[groupKey] || {
      items: [],
      sortOrder: item.sortOrder ?? 999, // default sortOrder if missing
      groupDate: item.groupDate || null,
    };
    acc[groupKey].items.push(item);
    return acc;
  }, {});

  const holidayItems = !isEmpty(holiday_list)
    ? holiday_list
      .map((item) => {
        const date = moment(item.date);
        if (date.isSame(today, "day")) {
          return { ...item, group: "Today", sortOrder: 0 };
        } else if (date.isSame(tomorrow, "day")) {
          return { ...item, group: "Tomorrow", sortOrder: 1 };
        } else if (date.isAfter(today)) {
          return {
            ...item,
            group: date.format("DD MMM YYYY"),
            sortOrder: 2,
            groupDate: date.toDate(),
          };
        }
        return null;
      })
      .filter(Boolean)
    : [];

  const groupedHolidays = holidayItems.reduce((acc, item) => {
    const key = item.group || "Others";
    acc[key] = acc[key] || {
      items: [],
      sortOrder: item.sortOrder ?? 999,
      groupDate: item.groupDate || null,
    };
    acc[key].items.push(item);
    return acc;
  }, {});

  const sortedHolidayGroups = Object.entries(groupedHolidays).sort((a, b) => {
    const [, aVal] = a;
    const [, bVal] = b;
    if (aVal.sortOrder !== bVal.sortOrder)
      return aVal.sortOrder - bVal.sortOrder;
    if (
      aVal.sortOrder === 2 &&
      aVal.groupDate instanceof Date &&
      bVal.groupDate instanceof Date
    )
      return aVal.groupDate - bVal.groupDate;
    return 0;
  });

  const upcomingHoliday = holiday_list
    .filter((item) => moment(item.date).isSameOrAfter(today, "day"))
    .sort((a, b) => moment(a.date) - moment(b.date))[0];

  const limitedHolidayGroups = sortedHolidayGroups.map(([label, val]) => ({
    label,
    items: val.items,
  }));

  const firstGroup =
    limitedHolidayGroups.length > 0 ? limitedHolidayGroups[0] : null;
    //designationOptions
  const designationOptions = !isEmpty(dropDownList.designationOptions)
    ? dropDownList.designationOptions.filter(item => item.departmentId === department.value)
    : [];
  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Dashboard | Mequals</title>
        </MetaTags>
      </div>
      <Row>
        <Col span={24} className="pb-2">
          <div className="font-poppins flex justify-between  pr-[20px]">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                  marginLeft: "7px",
                }}
                className="text-[16px]  mt-1 font-semibold"
              >
                {userType === "employee"
                  ? "Employee Dashboard"
                  : "Admin Dashboard"}
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      {userType === "employee" && (
        <>
          <Row gutter={[16, 16]} align="stretch" className="p-2">
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={8}
              style={{ display: "flex" }}
            >
              <div className="bg-white rounded-md shadow w-full">
                <div className="title-container">
                  <div className="profile-header p-2">
                    <Avatar
                      style={{
                        backgroundColor: "#8400ff",
                        textTransform: "capitalize",
                      }}
                      size={48}
                    >
                      {matchedEmployee?.employeeName?.[0] || "D"}
                    </Avatar>
                    <div className="info">
                      <Typography.Title
                        level={4}
                        style={{ color: "white", margin: 0, padding: 0 }}
                        className="poppins-txt"
                      >
                        {matchedEmployee?.employeeName || "No Name"}
                      </Typography.Title>
                      <Typography.Text
                        style={{ color: "white", whiteSpace: "nowrap" }}
                        className="poppins-txt"
                      >
                        {matchedEmployee?.designationId?.designationName ||
                          "No Designation"}
                      </Typography.Text>
                    </div>
                    <div className="edit-icon">
                      <EditOutlined style={{ color: "white" }} />
                    </div>
                  </div>
                </div>
                <div className="p-5">
                  <div>
                    <Typography className="grey-text">Phone Number</Typography>
                    <p style={{ fontSize: "14px" }} className="poppins-trxt">
                      {matchedEmployee?.mobileNumber || "No Phone Number"}
                    </p>
                  </div>

                  <div className="mt-1">
                    <Typography className="grey-text">Email Address</Typography>
                    <p style={{ fontSize: "14px" }} className="poppins-trxt">
                      {matchedEmployee?.emailId || "No Email"}
                    </p>
                  </div>

                  <div className="mt-1">
                    <Typography className="grey-text">Report office</Typography>
                    <p style={{ fontSize: "14px" }} className="poppins-trxt">
                      Mequals Technologies Private Limited
                    </p>
                  </div>

                  <div className="mt-1">
                    <Typography className="grey-text">Joined on</Typography>
                    <p style={{ fontSize: "14px" }} className="poppins-trxt">
                      {matchedEmployee?.joinDate
                        ? new Date(matchedEmployee.joinDate).toLocaleDateString(
                          "en-GB",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }
                        )
                        : "No Join Date"}
                    </p>
                  </div>
                </div>
              </div>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={10}
              style={{ display: "flex" }}
            >
              <div className="bg-white rounded-md shadow  w-full ">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography.Title
                    className="m-5 poppins-txt font-weight"
                    level={5}
                  >
                    Leave Details
                  </Typography.Title>
                  <div className="mr-5 mt-2">
                    <Dropdown overlay={menu} trigger={["click"]}>
                      <Button icon={<CalendarOutlined />}>
                        {selectedYear}
                      </Button>
                    </Dropdown>
                  </div>
                </div>
                <Divider className="my-4" />
                <Row gutter={16} className="p-5 pt-0">
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Total Apply Leave
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list?.appliedLeaveDays || 0}
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Approved
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list?.approvedLeaveDays || 0}
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Permission Hours
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list?.totalPermissionHours || 0}
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      LOP Hours
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list?.totalLopHours || 0}
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      General Leave
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list?.approvedGLDays || 0}
                    </p>
                  </Col>
                  <Col
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    style={{ marginTop: "10px" }}
                  >
                    <Typography
                      className="grey-text"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Worked Days
                    </Typography>
                    <p className="font-weight">
                      {Yearlyleave_list.workDays || 0}
                    </p>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    style={{ marginTop: "10px" }}
                  >
                    <Button
                      style={{
                        marginTop: "30px",
                        background: "#2E2928",
                        marginRight: "12px",
                        width: "100%",
                      }}
                      type="primary"
                      size="medium"
                      className="custom-btn"
                      onClick={() => showModalOpen()}
                    >
                      Apply New Leave
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={6}>
              <Row gutter={[16, 16]}>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  style={{ display: "flex" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#3F373B",
                      flexDirection: "column",
                    }}
                    className="rounded-md shadow w-full p-2"
                  >
                    <Typography.Title
                      level={4}
                      className="poppins-txt"
                      style={{ color: "#fff" }}
                    >
                      Team Birthday
                    </Typography.Title>

                    {grouped?.Today?.items?.length > 0 ? (
                      <>
                        <div>
                          <Avatar
                            style={{
                              backgroundColor: "#8400ff",
                              textTransform: "capitalize",
                            }}
                            size={48}
                          >
                            {grouped.Today.items[0].employeeName?.[0] || "U"}
                          </Avatar>
                        </div>
                        <div>
                          <Typography.Title
                            className="poppins-txt"
                            level={5}
                            style={{ color: "#fff" }}
                          >
                            {grouped.Today.items[0].employeeName}
                          </Typography.Title>
                        </div>
                        <div>
                          <Typography.Text className="poppins-txt grey-text">
                            {grouped.Today.items[0].designation || "N/A"}
                          </Typography.Text>
                        </div>
                        <div>
                          <Button
                            style={{
                              marginTop: "5px",
                              background: "#FF4500",
                            }}
                            type="primary"
                            size="medium"
                            className="custom-btn"
                            onClick={() => {
                              setWishesModalOpen(true);
                            }}
                          >
                            Send Wishes
                          </Button>
                        </div>
                      </>
                    ) : (
                      <Typography.Text
                        style={{ color: "#fff" }}
                        className="poppins-txt"
                      >
                        No Birthdays Today
                      </Typography.Text>
                    )}
                  </div>
                </Col>

                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  style={{ display: "flex" }}
                >
                  <div className="bg-[#F8F13A] rounded-md shadow w-full py-2 px-3">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Typography.Title
                          className="poppins-txt"
                          level={5}
                          style={{ color: "black", marginBottom: 0 }}
                        >
                          Next Holiday
                        </Typography.Title>
                      </div>

                      <div>
                        <Button
                          style={{
                            marginTop: "5px",
                            background: "#ffff",
                            color: "black",
                          }}
                          type="primary"
                          size="medium"
                          className="custom-btn"
                          onClick={() => {
                            setShowModal(true);
                          }}
                        >
                          View All
                        </Button>
                      </div>
                    </div>

                    <div>
                      {upcomingHoliday &&
                        firstGroup &&
                        firstGroup.items.length > 0 && (
                          <div style={{ marginTop: 10 }}>
                            <Typography.Text>
                              {upcomingHoliday
                                ? moment(upcomingHoliday.date).format(
                                  "MMM D, YYYY"
                                )
                                : "No upcoming holidays"}
                            </Typography.Text>

                            <div
                              key={`${firstGroup.items[0].holidayName}-0`}
                              style={{
                                background: "#F1FAFA",
                                borderRadius: 4,
                                padding: 8,
                                marginTop: 4,
                                border: "1px dashed gray",
                              }}
                            >
                              <Typography.Text
                                strong
                                style={{ textTransform: "capitalize" }}
                              >
                                {firstGroup.items[0].holidayName}
                              </Typography.Text>

                              <div
                                style={{
                                  color: "gray",
                                  fontSize: 12,
                                  textTransform: "capitalize",
                                }}
                              >
                                {firstGroup.items[0].description}
                              </div>

                              <div
                                style={{
                                  textAlign: "right",
                                  fontSize: 12,
                                  color: "#555",
                                }}
                              >
                                {moment(firstGroup.items[0].date).format(
                                  "ddd, MMM D"
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                    </div>

                    <Modal
                      title={"Holidays"}
                      open={showModal}
                      onCancel={handleHolidayModalCancel}
                      cancelText="Cancel"
                      width={450}
                      footer={null}
                      maskClosable={false}
                      centered
                    >
                      <div
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                          paddingRight: "8px",
                        }}
                      >
                        {limitedHolidayGroups.map(({ label, items }) => (
                          <div key={label} style={{ marginBottom: 16 }}>
                            <Typography.Text strong style={{ fontSize: 16 }}>
                              {label}
                            </Typography.Text>

                            {items.map((item, index) => (
                              <div
                                key={`${item.holidayName}-${index}`}
                                className="bg-[#F1FAFA] rounded-md shadow w-full my-2 border-dashed border border-gray-400"
                                style={{ padding: 10 }}
                              >
                                <div
                                  className="p-2 flex justify-between items-start gap-4"
                                  style={{ alignItems: "flex-start" }}
                                >
                                  {/* Left: Name and Description */}
                                  <div style={{ flex: 1 }}>
                                    <Typography.Text
                                      strong
                                      style={{
                                        textTransform: "capitalize",
                                        fontSize: 14,
                                      }}
                                    >
                                      {item.holidayName}
                                    </Typography.Text>
                                    <div
                                      style={{
                                        color: "gray",
                                        fontSize: 12,
                                        textTransform: "capitalize",
                                      }}
                                    >
                                      {item.description}
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      minWidth: "90px",
                                      textAlign: "right",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <Typography.Text
                                      style={{ fontSize: 12, color: "#555" }}
                                    >
                                      {moment(item.date).format("ddd, MMM D")}
                                    </Typography.Text>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </Modal>
                  </div>
                </Col>
              </Row>
            </Col>
            <Modal
              // title={"Send Wishes"}
              title={
                <div
                  style={{
                    color: "#fff",
                  }}
                >
                  Send Wishes
                </div>
              }
              open={wishesModelOpen}
              onCancel={handleWishesModalCancel}
              // cancelText="Cancel"
              closeIcon={<CloseOutlined style={{ color: "#fff" }} />}
              className="poppins-txt custom-active-modal"
              width={450}
              footer={null}
              maskClosable={false}
              // style={{ padding: 0 }}
              centered
              style={
                {
                  // This affects outer wrapper, leave default
                }
              }
              styles={{
                header: {
                  backgroundColor: "#3F373B",
                  padding: "16px 24px",
                },
              }}
            >
              <div className="custom-modal-content">
                <Col
                  xs={24}
                  style={{
                    marginTop: "5px",
                    paddingTop: "30px",
                    paddingBottom: "30px",
                  }}
                >
                  <TextArea
                    placeholder="Write your wishes here..."
                    rows={3}
                    name="wish"
                    value={wish}
                    onChange={(e) => handleWishChange(e)}
                  />
                </Col>
              </div>

              <div
                className="custom-modal-footer"
                style={{
                  borderTop: "1px solid #ccc",
                  padding: "10px 16px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className="custom-btn"
                  style={{
                    backgroundColor: "#f46a6a",
                    color: "#fff",
                    border: "none",
                    marginRight: "10px",
                  }}
                  onClick={() => handleWishesModalCancel()}
                >
                  Close
                </Button>
                <Button
                  disabled={disabled}
                  className="custom-btn"
                  onClick={() => handleDelete()}
                  style={{
                    backgroundColor: "#34c38f",
                    color: "#fff",
                    border: "none",
                  }}
                >
                  Send
                </Button>
              </div>
            </Modal>
            <Modal
              open={isModalVisible}
              onCancel={handleModalClose}
              title={
                <div
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    fontSize: "20px",
                  }}
                  className="poppins-txt"
                >
                  <span>Apply Leave</span>
                </div>
              }
              // title="Apply Leave"
              className="poppins-txt custom-active-modal"
              centered
              maskClosable={false}
              footer={null}
              width="70vw"
              maxWidth="1200px"
              style={{
                padding: 0,
                marginLeft: windowDimensions.width > 992 ? "220px" : "0",
              }}
            >
              <div className="custom-modal-content">
                <Row gutter={[16, 16]} style={{ marginTop: "2px" }}>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Employee Code
                        <span style={{ color: "red", marginLeft: "2px" }}>
                          *
                        </span>
                      </Typography>
                    </div>

                    <ReactSearchAutocomplete
                      name="employeeCodeList"
                      inputSearchString={employeeCodeList}
                      key={employeeCodeClear}
                      items={
                        showDropdown && dropDownList.employeeOptions
                          ? dropDownList.employeeOptions
                          : []
                      }
                      value={employeeCodeList}
                      type="autoComplete"
                      resultStringKeyName="label"
                      showIcon={false}
                      onChange={(e) => {
                        if (userType !== "employee")
                          setEmployeeCodeList(e.target.value);
                      }}
                      onFocus={() => {
                        if (userType !== "employee") setShowDropdown(true);
                      }}
                      onSelect={(item) => {
                        if (userType !== "employee") {
                          setEmployeeCodeList(item.label);
                          setEmployeePayloadId(item._id);
                          setShowDropdown(false);
                          handleEmployeeSelect(item);
                        }
                      }}
                      onSearch={(string, results) => {
                        if (userType !== "employee") setShowDropdown(true);
                      }}
                      onClear={() => {
                        if (userType !== "employee") handleEmployeeCodeClear();
                      }}
                      showClear={userType !== "employee"}
                      placeholder="Enter Employee code"
                      fuseOptions={fuseOptions}
                      className="text-end hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mb-[-6px]"
                      styling={{
                        height: "30px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        backgroundColor:
                          userType === "employee" ? "#f5f5f5" : "white",
                        pointerEvents:
                          userType === "employee" ? "none" : "auto",
                        opacity: userType === "employee" ? 0.6 : 1,
                        boxShadow: "none",
                        textAlign: "end",
                        hoverBackgroundColor: "lightgray",
                        color: "black",
                        fontSize: "12px",
                        fontFamily: "Poppins",
                        iconColor: "green",
                        clearIconMargin: "3px 8px 0 0",
                        zIndex: 10,
                      }}
                    />

                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "employeeCode",
                        employeeCodeList,
                        "required"
                      )}
                    </span>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Department
                      </Typography>
                    </div>
                    <Select
                      placeholder="Select department"
                      allowClear
                      className="custom-select"
                      name="department"
                      disabled={true}
                      value={department}
                      onChange={(value, options) => {
                        if (options) {
                          // normal selection
                          setDepartment({
                            label: options.label,
                            value: value,
                          });
                        } else {
                          // cleared selection
                          setDepartment({ label: "", value: "" });
                        }
                      }}
                      options={
                        !isEmpty(dropDownList)
                          ? dropDownList.departmentOptions
                          : []
                      }
                      autoComplete="off"
                      dropdownRender={(menu) => (
                        <h1 className="option-text-font">{menu}</h1>
                      )}
                    />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Designation
                      </Typography>
                    </div>
                    <Select
                      placeholder="Select designation"
                      allowClear
                      className="custom-select"
                      name="designation"
                      value={designation}
                      disabled={true}
                      onChange={(value, options) => {
                        if (options) {
                          // normal selection
                          setDesignation({
                            label: options.label,
                            value: value,
                          });
                        } else {
                          // cleared selection
                          setDesignation({ label: "", value: "" });
                        }
                      }}
                      options={designationOptions || []
                      }
                      autoComplete="off"
                      dropdownRender={(menu) => (
                        <h1 className="option-text-font">{menu}</h1>
                      )}
                    />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Leave Type
                        <span style={{ color: "red", marginLeft: "2px" }}>
                          *
                        </span>
                      </Typography>
                    </div>
                    <Select
                      placeholder="Select leave type"
                      allowClear
                      className="custom-select"
                      name="leaveType"
                      value={leaveType}
                      onChange={(value, options) => {
                        if (options) {
                          // normal selection
                          setLeaveType({
                            label: options.label,
                            value: value,
                          });
                        } else {
                          // cleared selection
                          setLeaveType({ label: "", value: "" });
                        }
                      }}
                      options={leaveOptions}
                      autoComplete="off"
                      dropdownRender={(menu) => (
                        <h1 className="option-text-font">{menu}</h1>
                      )}
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "leaveType",
                        leaveType,
                        "required"
                      )}
                    </span>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Leave Duration
                        <span style={{ color: "red", marginLeft: "2px" }}>
                          *
                        </span>
                      </Typography>
                    </div>
                    <Select
                      placeholder="Select leave type"
                      allowClear
                      className="custom-select"
                      name="leaveDuration"
                      value={leaveDuration}
                      onChange={(value, options) => {
                        if (options) {
                          // normal selection
                          setLeaveDuration({
                            label: options.label,
                            value: value,
                          });
                        } else {
                          // cleared selection
                          setLeaveDuration({ label: "", value: "" });
                        }
                        setLeaveDetails((prevData) => ({
                          ...prevData,
                          fromDate: "",
                          toDate: "",
                          leaveDays: "",
                        }));
                      }}
                      options={leaveDurationOptions}
                      autoComplete="off"
                      dropdownRender={(menu) => (
                        <h1 className="option-text-font">{menu}</h1>
                      )}
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "leaveDuration",
                        leaveDuration,
                        "required"
                      )}
                    </span>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div>
                      <div className="mb-2">
                        <Typography className="poppins-txt">
                          Leave From Date
                          <span style={{ color: "red", marginLeft: "2px" }}>
                            *
                          </span>
                        </Typography>
                      </div>
                      <DatePicker
                        className="custom-select py-2"
                        name="fromDate"
                        format="DD/MM/YYYY"
                        value={leaveDetails.fromDate}
                        onChange={(date) => handleDateChange("fromDate", date)}
                        minDate={dayjs().add(1, "day")} // Any date after today
                      />
                      <span
                        style={{
                          color: "#ef3022",
                          fontSize: "11px",
                          marginTop: "8px",
                          fontFamily: "poppins",
                          display: "block",
                        }}
                      >
                        {simpleValidator.current.message(
                          "fromDate",
                          leaveDetails.fromDate,
                          "required"
                        )}
                      </span>
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div>
                      <div className="mb-2">
                        <Typography className="poppins-txt">
                          Leave To Date
                        </Typography>
                      </div>
                      <DatePicker
                        className="custom-select py-2"
                        name="toDate"
                        format="DD/MM/YYYY"
                        value={
                          leaveDuration.value === "FullDay"
                            ? leaveDetails.toDate
                            : leaveDetails.fromDate
                        }
                        onChange={(date) => handleDateChange("toDate", date)}
                        disabled={leaveDuration.value !== "FullDay"}
                        minDate={leaveDetails.fromDate || null}
                        maxDate={
                          leaveDetails.fromDate
                            ? dayjs(leaveDetails.fromDate).add(1, "day") // Only up to 2 days
                            : null
                        }
                      />
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">Duration</Typography>
                    </div>
                    <Input
                      value={leaveDetails.leaveDays || ""}
                      readOnly
                      className="custom-select py-2"
                    />
                  </Col>

                  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Typography className="poppins-txt">
                      Attachment File
                    </Typography>
                    <div style={{ position: "relative", marginTop: 8 }}>
                      <Input
                        // value={imagePreviews.map((img) => img.name).join(", ")}
                        value={fileNames}
                        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"
                        placeholder="Choose File"
                        readOnly
                        // Clicking the input triggers the hidden file input click
                        onClick={() =>
                          document.getElementById("gallery-file-upload").click()
                        }
                        // Prefix with a filled cloud upload icon, styled larger with margin (gap)
                        prefix={
                          <CloudUploadOutlined
                            style={{
                              color: "blue",
                              fontSize: 24,
                              marginRight: 12, // Increase the gap between icon and placeholder
                            }}
                          />
                        }
                        style={{
                          cursor: "pointer",
                          paddingLeft: 8, // Adds a little more padding on the left for the text
                        }}
                      />

                      {/* Hidden file input overlay */}
                      <input
                        id="gallery-file-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleSinglePhoto} // <- change handler name too
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          opacity: 0,
                          width: "100%",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      />
                    </div>

                    {/* Image previews */}
                    {imagePreviews.length > 0 && (
                      <div style={{ marginTop: 16 }}>
                        {imagePreviews.map((img, imgsIndex) => (
                          <div
                            key={imgsIndex}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Typography
                              style={{
                                textDecoration: "underline",
                                color: "blue",
                                "&:hover": { color: "darkblue" },
                                fontSize: "14px",
                              }}
                              onClick={() => window.open(img.url, "_blank")}
                            >
                              View
                            </Typography>

                            <CloseOutlined
                              onClick={() => handleRemoveImage(imgsIndex)}
                              style={{
                                fontSize: 16,
                                color: "#ef3022",
                                padding: "2px",
                                marginLeft: "20px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </Col>

                  <Col xs={24} sm={24} md={17} lg={17} xl={17}>
                    <div className="mb-2">
                      <Typography className="poppins-txt">
                        Reason
                        <span style={{ color: "red", marginLeft: "2px" }}>
                          *
                        </span>
                      </Typography>
                    </div>
                    <TextArea
                      placeholder="Enter Reason"
                      rows={3}
                      name="reason"
                      value={leaveDetails.reason}
                      onChange={(e) => handleChange(e)}
                    />
                    <span
                      style={{
                        color: "#ef3022",
                        fontSize: "11px",
                        marginTop: "8px",
                        fontFamily: "poppins",
                        display: "block",
                      }}
                    >
                      {simpleValidator.current.message(
                        "reason",
                        leaveDetails.reason,
                        "required"
                      )}
                    </span>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={8}
                    lg={8}
                    xl={8}
                    style={{ marginTop: "30px" }}
                  >
                    <div>
                      <div className="mb-2">
                        <Typography className="poppins-txt">SL :</Typography>
                      </div>
                    </div>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={8}
                    lg={8}
                    xl={8}
                    style={{ marginTop: "30px" }}
                  >
                    <div>
                      <div className="mb-2">
                        <Typography className="poppins-txt">CL :</Typography>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

              {/* Custom footer with cancel and confirm buttons */}
              <div
                className="custom-modal-footer"
                style={{
                  borderTop: "1px solid #ccc",
                  padding: "10px 16px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className="custom-btn"
                  onClick={handleModalClose}
                  style={{
                    backgroundColor: "#f46a6a",
                    color: "#fff",
                    border: "none",
                    marginRight: "10px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disabled={disabled}
                  className="custom-btn"
                  style={{
                    backgroundColor: "#34c38f",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={() => setIsConfirmVisible(true)}
                >
                  Submit
                </Button>
              </div>
              <ToastContainer
                containerId="toast-1"
                position="top-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                style={{
                  fontSize: "12px",
                }}
                pauseOnHover
                theme="dark"
              />
            </Modal>
            <Modal
              open={isConfirmVisible}
              onCancel={() => setIsConfirmVisible(false)}
              title={"Confirmation"}
              // title="Apply Leave"
              className="poppins-txt custom-active-modal"
              centered
              maskClosable={false}
              width={450}
              footer={null}
              maxWidth="1200px"
              style={{
                padding: 0,
                marginLeft: windowDimensions.width > 992 ? "220px" : "0",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <p className="poppins-txt" style={{ padding: "15px" }}>
                  Are you sure Do you want to submit this request?
                </p>

                <div
                  className="custom-modal-footer"
                  style={{
                    borderTop: "1px solid #ccc",
                    padding: "10px 16px 0px 0px",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    className="custom-btn"
                    style={{
                      backgroundColor: "#f46a6a",
                      color: "#fff",
                      border: "none",
                      marginRight: "10px",
                    }}
                    onClick={() => setIsConfirmVisible(false)}
                  >
                    Close
                  </Button>
                  <Button
                    disabled={disabled}
                    className="custom-btn"
                    onClick={() => {
                      handleSubmit();
                      setIsConfirmVisible(false);
                    }}
                    style={{
                      backgroundColor: "#34c38f",
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    Confirm
                  </Button>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></div>
              </div>
            </Modal>
          </Row>

          <Row gutter={[16, 16]} align="stretch" className="p-2">
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={8}
              style={{ display: "flex" }}
            >
              <div
                className="bg-white rounded-md shadow  w-full  "
                style={{ border: "1px solid #FF5733" }}
              >
                <div className="attendance-center p-5">
                  <div type="secondary" className="poppins-txt">
                    Attendance
                  </div>
                  <div
                    className="font-weight horizontal-container "
                    style={{ width: "200px" }}
                  >
                    <div className="time-display">
                      <p ref={timeDisplayRef}>
                        {moment().format("DD-MM-YYYY")}
                      </p>
                    </div>
                    <div className=" date-display">
                      <p ref={timeDisplayRef}>
                        {moment(timeRef.current).format("hh:mm:ss A")}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      width: 150,
                      height: 150,
                      margin: "0 auto",
                      position: "relative",
                    }}
                  >
                    <PieChart width={140} height={155}>
                      <Pie
                        data={pieData}
                        cx="50%"
                        cy="50%"
                        innerRadius={65}
                        outerRadius={70}
                        startAngle={90} // 12 o'clock
                        endAngle={-270} // full circle clockwise
                        dataKey="value"
                      >
                        {pieData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={index === 0 ? "#28a745" : "#e0e0e0"} // First is worked (green), second is remaining (grey)
                          />
                        ))}
                      </Pie>
                    </PieChart>
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        textAlign: "center",
                      }}
                    >
                      <div
                        className="grey-text"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Total Hours
                      </div>
                      <div className="font-weight">{totalWorked}</div>
                    </div>
                  </div>

                  <Button
                    style={{
                      marginTop: "5px",
                      background: "#2E2928",
                      marginBottom: "10px",
                      marginRight: "12px",
                    }}
                    type="primary"
                    size="medium"
                    className="custom-btn"
                  >
                    Production : {formattedWorkedHours}
                  </Button>
                  <Typography.Text>
                    {punchInTime && (
                      <Typography.Text>
                        Punch In at {punchInTime}
                      </Typography.Text>
                    )}
                  </Typography.Text>
                  <Button
                    disabled={disabled || isPunchOutDone}
                    loading={loader}
                    style={{
                      marginTop: "20px",
                      background: "#FF4500",
                      marginRight: "12px",
                      width: "100%",
                    }}
                    type="primary"
                    size="medium"
                    className="custom-btn"
                    onClick={handlePunch}
                  >
                    {isPunchedIn ? "Punch Out" : "Punch In"}
                  </Button>
                </div>
              </div>
            </Col>

            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={16}
              style={{ display: "flex" }}
            >
              <Row gutter={[16, 16]}>
                <Col
                  xs={24}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ display: "flex" }}
                >
                  <div className="bg-white rounded-md shadow  w-full p-5">
                    <Button
                      style={{
                        // marginTop: "20px",
                        background: "#FF4500",
                        marginBottom: "10px",
                        // marginRight: "12px",
                      }}
                      type="primary"
                      size="small"
                      className="custom-btn"
                    >
                      <ClockCircleOutlined />
                    </Button>
                    <div>
                      <Typography.Text
                        style={{ fontSize: 23, marginRight: 4 }}
                        className="font-weight"
                      >
                        {todayHours} /
                      </Typography.Text>
                      <Typography.Text
                        style={{ fontSize: 23 }}
                        type="secondary"
                      >
                        {" "}
                        9
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        className="grey-text"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Total Hours Today
                      </Typography.Text>
                    </div>
                    <Divider className="my-3" />
                    <Space>
                      <UpCircleFilled
                        style={{
                          color: "#52C41A",
                          padding: 4,
                          fontSize: "20px",
                        }}
                      />
                      <Typography.Text className="grey-text">
                        {todayPercentage}% This Week
                      </Typography.Text>
                    </Space>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ display: "flex" }}
                >
                  <div className="bg-white rounded-md shadow  w-full p-5">
                    <Button
                      style={{
                        // marginTop: "20px",
                        background: "#2E2928",
                        marginBottom: "10px",
                        // marginRight: "12px",
                      }}
                      type="primary"
                      size="small"
                      className="custom-btn"
                    >
                      <ClockCircleOutlined />
                    </Button>
                    <div>
                      <Typography.Text
                        style={{ fontSize: 23, marginRight: 4 }}
                        className="font-weight"
                      >
                        {weekHours} /
                      </Typography.Text>
                      <Typography.Text
                        style={{ fontSize: 23 }}
                        type="secondary"
                      >
                        {" "}
                        40
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        className="grey-text"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Total Hours Week
                      </Typography.Text>
                    </div>
                    <Divider className="my-3" />
                    <Space>
                      <UpCircleFilled
                        style={{
                          color: "#52C41A",
                          fontSize: "20px",
                        }}
                      />
                      <Typography.Text className="grey-text">
                        {weekPercentage}% Last Week
                      </Typography.Text>
                    </Space>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  style={{ display: "flex" }}
                >
                  <div className="bg-white rounded-md shadow  w-full p-5">
                    <Button
                      style={{
                        // marginTop: "20px",
                        // background: "#F60DAC",
                        marginBottom: "10px",
                        // marginRight: "12px",
                      }}
                      type="primary"
                      size="small"
                      className="custom-btn"
                    >
                      <CalendarOutlined />
                    </Button>
                    <div>
                      <Typography.Text
                        style={{ fontSize: 23, marginRight: 4 }}
                        className="font-weight"
                      >
                        {monthHours} /
                      </Typography.Text>
                      <Typography.Text
                        style={{ fontSize: 23 }}
                        type="secondary"
                      >
                        {" "}
                        98
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        className="grey-text"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Total Hours Month
                      </Typography.Text>
                    </div>
                    <Divider className="my-3" />
                    <Space>
                      <DownCircleFilled
                        style={{
                          color: "#F60D0D",
                          fontSize: "20px",
                        }}
                      />
                      <Typography.Text className="grey-text">
                        {monthPercentage}% Last Month
                      </Typography.Text>
                    </Space>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  style={{ display: "flex" }}
                >
                  <div className="bg-white rounded-md shadow  w-full p-5">
                    <Row gutter={16}>
                      <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            type="secondary"
                            className="poppins-txt"
                          >
                            <span
                              style={{
                                color: "#EAE4D6",
                                fontWeight: "100",
                                marginRight: 4,
                                fontSize: "25px",
                                lineHeight: "1",
                                verticalAlign: "middle",
                              }}
                            >
                              &#8226;
                            </span>{" "}
                            Total Working hours
                          </Typography.Text>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            strong
                            style={{ fontSize: 20 }}
                            className="poppins-txt"
                          >
                            {totalWorked}
                          </Typography.Text>
                        </div>
                      </Col>
                      <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            type="secondary"
                            className="poppins-txt"
                          >
                            <span
                              style={{
                                color: "green",
                                fontWeight: "100",
                                marginRight: 4,
                                fontSize: "25px",
                                lineHeight: "1",
                                verticalAlign: "middle",
                              }}
                            >
                              &#8226;
                            </span>{" "}
                            Productive hours
                          </Typography.Text>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            strong
                            style={{ fontSize: 20 }}
                            className="poppins-txt"
                          >
                            {formattedWorkedHours}
                          </Typography.Text>
                        </div>
                      </Col>
                      <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            type="secondary"
                            className="poppins-txt"
                          >
                            <span
                              style={{
                                color: "yellow",
                                fontWeight: "100",
                                marginRight: 4,
                                fontSize: "25px",
                                lineHeight: "1",
                                verticalAlign: "middle",
                              }}
                            >
                              &#8226;
                            </span>{" "}
                            Break hours
                          </Typography.Text>
                        </div>
                        <div style={{ textAlign: "center" }}>
                          <Typography.Text
                            strong
                            style={{ fontSize: 20 }}
                            className="poppins-txt"
                          >
                            {breakHours}
                          </Typography.Text>
                        </div>
                      </Col>
                    </Row>

                    <div style={{ width: "100%", marginTop: "16px" }}>
                      {/* Progress Segments */}
                      <div
                        style={{
                          height: "34px",
                          display: "flex",
                          gap: "2px",
                          backgroundColor: "#E6DCE8",
                          borderRadius: "8px",
                        }}
                      >
                        {segments.map((segment, index) => (
                          <div
                            key={index}
                            style={{
                              width: `${segment.width}%`,
                              backgroundColor: segment.color,
                              borderRadius: "5px",
                              height: "100%",
                            }}
                          />
                        ))}
                      </div>

                      {/* Time Labels */}
                      <div
                        style={{
                          position: "relative",
                          height: "20px",
                          marginTop: "6px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      >
                        {clockLabels.map((label, index) => (
                          <div
                            key={index}
                            style={{
                              position: "absolute",
                              left: `${(index / (clockLabels.length - 1)) * 100
                                }%`,
                              transform: "translateX(-50%)",
                              fontSize: "10px",
                              color: "#A0A0A0",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {label}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            style={{
              fontSize: "12px",
            }}
            pauseOnHover
            theme="dark"
          />
        </>
      )}
      {userType === "admin" && (
        <>
          <AdminDashboard />
        </>
      )}
    </React.Fragment>
  );
};

export default Dashboard;
